<div class="courses-card" [ngClass]="cardClass" *ngIf="courses && courses.length > 0">
  <h3>{{ title }}</h3>
  <div class="courses-total" *ngIf="showTotals">
    <span class="courses-total-label">{{ totalsLabel }}</span>
    <div class="course-hours">
      <span class="hour-item"><strong>CLE:</strong> {{ totalsCle | number:'1.0-2' }}</span>
      <span class="hour-item"><strong>Ethics:</strong> {{ totalsEthics | number:'1.0-2' }}</span>
      <span class="hour-item"><strong>Prof:</strong> {{ totalsProf | number:'1.0-2' }}</span>
      <span class="hour-item fee" *ngIf="showFee" aria-hidden="true"></span>
    </div>
  </div>
  <div class="courses-list">
    <div class="course-item" *ngFor="let course of courses">
      <div class="course-header">
        <h4 class="course-name">{{ courseTitle(course) }}</h4>
        <span class="course-date">{{ course.dateTaken | date: 'mediumDate' }}</span>
      </div>
      <div class="course-footer">
        <div class="course-sponsor" *ngIf="course.sponsorName && !isBonusCourse(course)">
          <strong>Sponsor:</strong> {{ course.sponsorName }}
        </div>
        <div class="course-hours">
          <span class="hour-item"><strong>CLE:</strong> {{ (course.totalCle ?? 0) | number:'1.0-2' }}</span>
          <span class="hour-item"><strong>Ethics:</strong> {{ ((course.ethics ?? course.sumOfEthics) ?? 0) | number:'1.0-2' }}</span>
          <span class="hour-item"><strong>Prof:</strong> {{ ((course.prof ?? course.sumOfProf) ?? 0) | number:'1.0-2' }}</span>
          <span class="hour-item fee" *ngIf="showFee && course.memberFee != null"><strong>Fee:</strong> {{ course.memberFee | currency }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
